export const SolutionsProviderTypeDecorator = {
  url() {
    return `signup-hubspot/solutions-provider`;
  },
  query() {
    return {};
  }
};